export * from './ports/types';
export { MockImageAsset } from './mocks/mockImageAsset';

export {
  ImageLoader,
  type LoadedRawImage,
  type ImageDecoder,
  type ImageLoaderOptions,
} from './internal/ImageLoader';

export {
  AspectRatioFitter,
  type CanvasFitLayout,
  type UVCoordResult,
  type CanvasCoordResult,
} from './internal/AspectRatioFitter';

export {
  PresetCatalog,
  type PresetDefinition,
} from './internal/PresetCatalog';

export {
  ImageAssetService,
  type ImageAssetServiceOptions,
} from './internal/ImageAssetService';

import { IImageAssetPort } from './ports/types';
import { ImageAssetService, ImageAssetServiceOptions } from './internal/ImageAssetService';

/**
 * ImageAssetPort のファクトリ関数
 * 本番・プロトタイプ向けの本実装ファサード (ImageAssetService) を生成して返却
 */
export function createImageAssetPort(options?: ImageAssetServiceOptions): IImageAssetPort {
  return new ImageAssetService(options);
}
